import { useDrawer } from '@core/context/DrawerContext'
import { Wrapper } from '@ui/drawer/caseDetails/caseDetails.styles'
import CaseTabs from '@ui/drawer/caseDetails/components/caseTabs/caseTabs'
import { Body, Title, DescriptionTitle } from './caseDetails.styles'

const CaseDetails = () => {
    const { drawerState } = useDrawer()
    const { currentIndex, cases, currentTab } = drawerState?.contentProps || {}
    const caseData = cases?.[currentIndex]

    if (!caseData) return null

    return (
        <Wrapper>
            <Body>
                <DescriptionTitle component="h3" variant="s-bold">
                    Description
                </DescriptionTitle>
                <Title
                    variant="s-regular"
                    testId="case-description"
                    component="span"
                    className="text"
                    noWrap={false}
                >
                    {caseData.description}
                </Title>
                <CaseTabs caseData={caseData} currentTab={currentTab} />
            </Body>
        </Wrapper>
    )
}

export default CaseDetails
